import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';

import { WithStyles, createStyles, Typography, Button, Modal, Card, CardContent, CardActions, CardHeader, IconButton, FormControl, InputLabel, Select, MenuItem, Grid, Paper, Link, TableHead, Table, TableBody, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

import { MyPATCollapse, MyPATLink, dateService, MyPATDialog } from '../../common';
import { BorderAll } from '@material-ui/icons';
import { parseTime } from '../../../utils/getOffset.utils';


const styles = (theme: Theme) => createStyles({
    TestAnalyticsCard:{
        border: '1px solid #D8D0D0',
        borderRadius: 4,
        width: '100%',
        margin: '10px 0 12px 0',
        '& table':{
            '& tbody':{
                '& tr':{
                    borderBottom: '1px solid #D8D0D0',
                    '&:last-child':{
                        borderBottom: 'none',
                    },
                    '& td':{
                        fontSize: '12px',
                        padding: '7px 5px',
                        '&:first-child':{
                            borderRight: '1px solid #D8D0D0',
                            backgroundColor: '#F1F1F1',
                            paddingRight: '12px',
                            width: '45%',
                            borderTopLeftRadius: '4px',
                        },
                        '&:last-child':{
                            borderBottomLeftRadius: '4px',
                        }
                    }
                }
            }
        }
    },
    textRight:{
        textAlign: 'right',
    },
    textCenter:{
        textAlign: 'center',
    },
    noteTxt:{
        fontSize: 14,
        lineHeight: '24px',
        color: '#333',
        '&>span':{
            fontWeight: 600,
            textTransform: 'uppercase'
        }
    },
    textTruncate:{
        // textOverflow: 'ellipsis',
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // width: '110px',
        // display: 'inline-block',
    }
});

//@ts-ignore
interface TestAnalyticsProps extends WithStyles<typeof styles> {
    classes: any,
    content: any
}



interface TestAnalyticsStates {}

class TestAnalytics extends Component<TestAnalyticsProps, TestAnalyticsStates>{	
    columns: any = {
        totalAttempts: 'No. of Attempts',
        avgAttemptRate: 'Avg. Attempt Rate',
        avgAccuracyRate: 'Avg. Accuracy Rate',
        avgTimeTakenInSeconds: 'Avg. Time Taken',
        status: 'Status'
      };
    constructor(props: TestAnalyticsProps) {
        super(props);
        this.handleTestAnalytics = this.handleTestAnalytics.bind(this);
    }
    
    handleDialogClose = () => {
        //add your code
    }
    addTestAnalytics (){
        //add your code
    }
    handleTestAnalytics(){
        //add your code
    }
    
    renderItem(value: any, key: string) {
        if(key == 'avgTimeTakenInSeconds') return parseTime(value)
        else if(key == 'avgAttemptRate' || key == 'avgAccuracyRate') return `${value}%`
        else if(key == 'status') return `${value.finishedAttemptCount} Completed ${value.ongoingAttemptCount} Ongoing`
        else return value
    }

    parseData(data: any) {
        return {
          totalAttempts: data.totalAttempts,
          avgAttemptRate: Math.floor(data.avgAttemptRate),
          avgAccuracyRate: Math.floor(data.avgAccuracyRate),
          avgTimeTakenInSeconds: data.avgTimeTakenInSeconds,
          status: {
            finishedAttemptCount: data.finishedAttemptCount,
            ongoingAttemptCount: data.ongoingAttemptCount
          }
        }
    }

    renderAnalytics() {
        //add your code
        const { content: c, classes } = this.props;
        if (c) {
          if (c.data.analyticsData && Object.keys(c.data.analyticsData).length) {
            const dataObj: any = this.parseData(c.data.analyticsData)
            const analytics = Object.keys(dataObj)
            .map((key: string) => (
            <tr>
             <td className={classes.textRight}><span className={classes.textTruncate}>{this.columns[key]}</span></td>
             <td className={classes.textCenter}><span className={classes.textTruncate}>
                 
                 {this.renderItem(dataObj[key], key)}
                 
                 </span></td>
            </tr>
            ));

            return (
              <Table>
                <tbody>{analytics}</tbody>
              </Table>
            );
          } else return c.message;
        } else return "";
      }
	render() {
        const { classes, content: c} = this.props;
		return (
            <>
			{/* <MyPATCollapse title="Test Analytics"> */}
                <Grid container direction="row" justify="center" alignItems="center">   
                    <Grid className={classes.TestAnalyticsCard}>
                        {/* <Table>
                            <tbody>
                                <tr>
                                    <td className={classes.textRight}><span className={classes.textTruncate}>No. of Attempts</span></td>
                                    <td className={classes.textCenter}><span className={classes.textTruncate}>100</span></td>
                                </tr>
                                <tr>
                                    <td className={classes.textRight}><span className={classes.textTruncate}>Avg. Attempt Rate</span></td>
                                    <td className={classes.textCenter}><span className={classes.textTruncate}>45%</span></td>
                                </tr>
                                <tr>
                                    <td className={classes.textRight}><span className={classes.textTruncate}>Avg. Accuracy Rate</span></td>
                                    <td className={classes.textCenter}><span className={classes.textTruncate}>45%</span></td>
                                </tr>
                                <tr>
                                    <td className={classes.textRight}><span className={classes.textTruncate}>Avg. Time Taken</span></td>
                                    <td className={classes.textCenter}><span className={classes.textTruncate}>34 min 5 sec</span></td>
                                </tr>
                                <tr>
                                    <td className={classes.textRight}><span className={classes.textTruncate}>Status</span></td>
                                    <td className={classes.textCenter}><span className={classes.textTruncate}>95 Completed, 5 Ongoing</span></td>
                                </tr>
                            </tbody>
                        </Table>  
                        */}
                        {this.renderAnalytics()}                      
                    </Grid>
                        {c && c.data.analyticsData && Object.keys(c.data.analyticsData).length && 
                            <Typography className={classes.noteTxt}><span>* NOTE:</span>  This data is for serious attempts only</Typography>          
                        }
                </Grid> 
            {/* </MyPATCollapse>            */}
            
        </>
        );
	}

}

// @ts-ignore
export default withStyles(styles)(TestAnalytics);

